import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const GameListPage = () =>
  import('@modules/game/components/game-list-page.vue');
const GameFormPage = () =>
  import('@modules/game/components/game-form-page.vue');
const GameViewPage = () =>
  import('@modules/game/components/game-view-page.vue');

export default [
  {
    name: '',
    path: '/program/:programId/subprogram/:subprogramId',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'game',
        path: 'game',
        component: GameListPage,
        meta: {
          auth: true,
          permission: Permissions.values.gameView,
        },
      },
      {
        name: 'gameNew',
        path: 'game/new',
        component: GameFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.gameCreate,
        },
      },
      {
        name: 'gameEdit',
        path: 'game/:id/edit',
        component: GameFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.gameEdit,
        },
        props: true,
      },
      {
        name: 'gameView',
        path: 'game/:id',
        component: GameViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.gameView,
        },
        props: true,
      },
    ],
  },
];
